import { useState, useEffect, useRef } from 'react'
import debounce from 'lodash.debounce'

export function useDebouncedValueWithLoading<T>(value: T, delay: number): [T, boolean] {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const [loading, setLoading] = useState(false)
  const isMountedRef = useRef(true)
  const didMountRef = useRef(false)

  useEffect(() => {
    isMountedRef.current = true

    if (!didMountRef.current) {
      didMountRef.current = true
      return
    }

    setLoading(true)

    const handler = debounce((val: T) => {
      if (!isMountedRef.current) {
        return
      }
      setDebouncedValue(val)
      setLoading(false)
    }, delay)

    handler(value)

    return () => {
      isMountedRef.current = false
      handler.cancel()
    }
  }, [value, delay])

  return [debouncedValue, loading]
}
